import React from 'react';
import WhiteCard from './WhiteCard';

function InfoCamp({ nome }) {
  return (
    <WhiteCard style={styles.card}>
      <div style={styles.cardHeader}>
        <strong style={styles.nome}>{nome}</strong>
        <span style={styles.qrCode}>QR CODE</span>
      </div>
      <div style={styles.content}>
        <p style={styles.info}>Saldo lanchonete: <strong>R$ 100,00</strong></p>
        <p style={styles.linkContainer}>
          <a href="#" style={styles.link}>Ver extrato da lanchonete</a>
        </p>
        <div style={styles.cardFooter}></div>
        <p style={styles.info}>Situação cadastral: <strong>ativo</strong></p>
        <p style={styles.info}>Tipo de cota: <strong>temporária ou permanente</strong></p>
        <p style={styles.info}>Pagamento: <strong>anuidade ou semestral</strong></p>
        <p style={styles.info}>Valor: <strong>R$ 600,00</strong></p>
        <p style={styles.info}>Vencimento: <strong>26/04/2026</strong></p>
      </div>
      <div style={styles.cardFooter}>
        <p style={styles.info}>Taxa de cota: <strong style={{ color: '#DC2626' }}>em débito</strong></p>
        <button style={styles.botao}>Enviar lembrete</button>
      </div>
    </WhiteCard>
  );
}

export default InfoCamp;

// 🎨 Estilos
const styles = {
  card: {
    width: '100%',
    textAlign: 'left', // Alinhamento geral à esquerda
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    textAlign: 'left',
  },
  nome: {
    color: '#111827',
    fontSize: '18px',
    fontWeight: '600',
    textAlign: 'left',
  },
  qrCode: {
    color: '#2563EB',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: '#EFF6FF',
    padding: '4px 8px',
    borderRadius: '6px',
    textAlign: 'right', // Mantém o QR Code alinhado à direita
  },
  content: {
    textAlign: 'left',
  },
  info: {
    margin: '4px 0',
    color: '#374151',
    textAlign: 'left',
  },
  linkContainer: {
    textAlign: 'left',
    marginTop: '8px',
  },
  link: {
    color: '#1D4ED8',
    textDecoration: 'none',
    fontWeight: '500',
    display: 'inline-block',
    textAlign: 'left',
  },
  cardFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '16px',
    flexWrap: 'wrap',
    gap: '8px',
    textAlign: 'left',
  },
  botao: {
    backgroundColor: '#10B981',
    color: '#fff',
    fontSize: '14px',
    fontWeight: '600',
    border: 'none',
    borderRadius: '999px',
    padding: '8px 16px',
    cursor: 'pointer',
    textAlign: 'center',
  }
};